import React, { useEffect, useState } from 'react'
import EnvVar from "./EnvVar";
import axios from "axios";
import Cookies from "js-cookie";
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useRole } from './RoleContext';
import { useAuth } from './AuthContext';


function AuthGaurd() {
    // const [loginRole, setLoginRole] = useState()
    // const [trigger, setTrigger] = useState(false)
    const baseURL = EnvVar()
    const token = Cookies.get("jwt")
    const navigate = useNavigate()
    const location = useLocation()
    const { setRole } = useRole(); // Get setRole from context
    const { isAuthenticated } = useAuth(); // Get isAuthenticated from context
    let locationPath = location.pathname

    useEffect(() => {
        // console.log("locationPath==>", locationPath);
        let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${baseURL}/auth/isLoggedin`,
            headers: {
                Authorization: token,
            },
            withCredentials: true,
        };

        axios
            .request(config)
            .then((response) => {
                let result = JSON.stringify(response.data);
                let data = JSON.parse(result);
                setRole(data.role)
                redirectBro(data.status, data.role);
                // console.log(`isLogin value is ${data.status} and it's type of ${typeof (data.status)} and complete data==> ${data.role}`);
            })
            .catch((error) => {
                console.log("Error fetching data:", error);
                redirectBro()
            });


        // Redirect the user to the appropriate page based on their login status
        function redirectBro(isLogin, role) {
            // console.log('role', role, "and isLogin" ,isLogin)
            if (isLogin) {
                if (locationPath === "/ambassador/registration" || locationPath === "/ambassador/login" ) {
                    switch (role) {
                        case "admin":
                        case "CCM":
                        case "RCM":
                        case "branch":
                            navigate('/ambassador/admin-dash');
                            break;
                        case "ambassador":
                            navigate('/ambassador/dash')
                            break;
                        default:
                            break;
                    }
                } else {
                    navigate(locationPath)
                }
            } else {
                if (locationPath !== "/ambassador/registration" && locationPath !== "/ambassador/login" && locationPath !== "/ambassador") {
                    navigate('/ambassador/login')
                }
                else {
                    navigate(locationPath)
                }
            }
        }

        // redirectBro()

    }, [isAuthenticated, locationPath])
    return (
        <>
            <Outlet />
        </>
    )
}

export default AuthGaurd
